import { PlainTooltip } from "app/components/React/Tooltip/PlainTooltip/PlainTooltip";
import type { ITableCellProps } from "../../interfaces/ITableCellProps";
import { CellContainer } from "./styled";

export const AccountNameCell = ({ row: { AccountName: accountName } }: ITableCellProps): React.JSX.Element => (
    <PlainTooltip
        placement="top"
        text={accountName}
    >
        <CellContainer>{accountName}</CellContainer>
    </PlainTooltip>
);
